import { render, staticRenderFns } from "./Commanditaires.vue?vue&type=template&id=33a22364&scoped=true&"
import script from "./Commanditaires.vue?vue&type=script&lang=js&"
export * from "./Commanditaires.vue?vue&type=script&lang=js&"
import style0 from "./Commanditaires.vue?vue&type=style&index=0&id=33a22364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a22364",
  null
  
)

export default component.exports